import { useMemo } from 'react';

import { Channel } from '@/models/channelModels';
import { useAppSelector } from '@/redux/hooks';
import { RootState } from '@/redux/rootReducer';
import { getCapabilities } from '@/util/capabilities';

export function useCapabilities() {
  const channel = useAppSelector((s: RootState) => s.auth?.channel ?? Channel.DEFAULT);
  const company = useAppSelector((s: RootState) => s.auth?.companyAccount ?? null);

  return useMemo(() => getCapabilities(channel, company), [channel, company]);
}
